var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[(_vm.erros.length > 0)?_c('app-erros-box',{attrs:{"erros":_vm.erros}}):_vm._e(),_c('app-tabela',{attrs:{"idTabela":"tblHistoricoUsuario","itens":_vm.historico,"campos":_vm.campos,"itensPorPagina":_vm.itensPorPagina,"bordered":false,"small":false},scopedSlots:_vm._u([{key:"vigencia",fn:function(data){return [_vm._v("\n                "+_vm._s(data.dtLog
                        ? _vm.$moment(data.dtLog).format(
                              'DD/MM/YYYY  HH:mm:ss'
                          )
                        : '')+"\n            ")]}}])})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }